<template>
    <div class="newsPage">
        <div class="top">
            <img src="../img/logo.png" alt="">
            <div class="line"></div>
            <img src="../img/min_title.png" alt="" class="imgRight">
        </div>
        <div class="main">
            <div class="title">
                榜样的力量 • 孔子学院光荣榜
            </div>
            <swiper :options="swiperOption" ref="awardsSwiper" class="firstWrapper">
                <swiper-slide  class="firstSwiper ">
                    <img src="../img/person.png" alt="" >
                </swiper-slide>
                <swiper-slide  class="firstSwiper">
                    <img src="../img/organization.png" alt="" >
                </swiper-slide>
                <swiper-slide  class="firstSwiper">
                    <img src="../img/cio.png" alt="" >
                </swiper-slide>

            </swiper>
        </div>
        <div class="modalCon" v-if="isShow">
            <div class="modalBg"></div>
            <div class="modal">
                <div class="topBg">
                    
                </div>
                <div class="modalContent">
                    <div class="close" @click="close"></div>
                    <div class="content" v-if="current == 2">
                        <div class="title">
                            <div>
                                先进孔子学院/课堂
                            </div>
                            <div>
                                Confucius Institutes (Classrooms) 
                            </div>
                            <div>
                                of the Year
                            </div>
                        </div>
                        <div class="list classroomList" v-if="$i18n.locale=='cn'">
                            <span class="tip">按国家名称英文字母排序/In alphabetical order by country name</span>
                            <div>
                                <div v-for="item in awardList.classroom.cn" :key="item.name" class="item classroomItem">
                                    {{item.name}}
                                </div>
                            </div>
                            
                        </div>
                        <div class="list classroomList" v-if="$i18n.locale=='en'">
                            <span class="tip">按国家名称英文字母排序/In alphabetical order by country name</span>
                            <div>
                                <div v-for="item in awardList.classroom.en" :key="item.name" class="item classroomItem_en">
                                    {{item.name}}
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class="content" v-if="current == 0">
                        <div class="title">
                            <div>
                                孔子学院先进个人
                            </div>
                            <div>
                                Confucius Institute Individual
                            </div>
                            <div>
                                Performance Excellence Award Recipients
                            </div>
                        </div>
                        <div class="list personList" v-if="$i18n.locale=='cn'">
                            <span class="tip">按国家名称英文字母排序/In alphabetical order by country name</span>
                            <div>
                                <div v-for="item in awardList.person.cn" :key="item.name" class="item">
                                    <span class="realName">{{item.name}} </span>
                                    <!-- <span>{{item.country}}</span> -->
                                    <div class="profile">
                                        {{item.profile}}
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        <div class="list personList" v-if="$i18n.locale=='en'">
                            <span class="tip">按国家名称英文字母排序/In alphabetical order by country name</span>
                            <div>
                                <div v-for="item in awardList.person.en" :key="item.name" class="item">
                                    <span class="realName">{{item.name}} </span>
                                    <!-- <span>{{item.country}}</span> -->
                                    <div class="profile">
                                        {{item.profile}}
                                    </div>
                                </div>
                            </div>
                             
                        </div>
                    </div>
                    <div class="content" v-if="current == 1">
                        <div class="title">
                            <div>
                                先进中方合作机构
                            </div>
                            <div>
                                Outstanding Confucius Institute
                            </div>
                            <div>
                                Chinese Partners
                            </div>
                        </div>
                        <div class="list" v-if="$i18n.locale=='cn'">
                            <div v-for="item in awardList.partner.cn" :key="item.name" class="item partnerItem">
                                <span class="realName">{{item.name}} </span>
                            </div>
                        </div>
                        <div class="list" v-if="$i18n.locale=='en'">
                             <div v-for="item in awardList.partner.en" :key="item.name" class="item partnerItem partnerItem_en">
                                <span class="realName">{{item.name}} </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        
    </div>
</template>

<script>
export default {
  name: 'awards',
  data: function() {
      return {
            isSlide: false,
            swiperOption: {
                slidesPerView: 3,
                spaceBetween: 10,
                centeredSlides: true,
                loop: true,
                
                slideToClickedSlide: true,
                preventLinksPropagation:false,
                on:{
                    tap: (e) => {
                        let i = this.awardsSwiper.realIndex
                        if(this.isSlide){
                            this.showModal(i)
                        }
                    },
                    transitionStart: () => {
                        this.isSlide = false
                    },
                    slideChangeTransitionEnd: () => {
                        this.isSlide = true
                    },
                },
            },
            current: null,
            isShow: false,
            awardList : {
                classroom: {
                    cn: [
                        {
                            name: '阿根廷布宜诺斯艾利斯大学孔子学院'
                        },
                        {
                            name: '澳大利亚新南威尔士大学孔子学院'
                        },
                        {
                            name: '澳大利亚西澳大利亚大学孔子学院'
                        },
                        {
                            name: '比利时西弗兰德大学学院孔子学院'
                        },
                        {
                            name: '巴西帕拉州立大学孔子学院'
                        },
                        {
                            name: '埃及苏伊士运河大学孔子学院'
                        },
                        {
                            name: '法国洛林大学孔子学院'
                        },
                        {
                            name: '德国法兰克福大学孔子学院'
                        },
                        {
                            name: '爱尔兰科克大学孔子学院'
                        },
                        {
                            name: '意大利米兰天主教圣心大学孔子学院'
                        },
                        {
                            name: '日本大阪产业大学孔子学院'
                        },
                        {
                            name: '老挝国立大学孔子学院'
                        },
                        {
                            name: '马达加斯加塔那那利佛大学孔子学院'
                        },
                        {
                            name: '马来西亚马来亚大学孔子学院'
                        },
                        {
                            name: '新西兰惠灵顿维多利亚大学孔子学院'
                        },
                        {
                            name: '尼日利亚拉各斯大学孔子学院'
                        },
                        {
                            name: '巴拿马大学孔子学院'
                        },
                        {
                            name: '俄罗斯乌拉尔联邦大学孔子学院'
                        },
                        {
                            name: '塞尔维亚诺维萨德大学孔子学院'
                        },
                        {
                            name: '南非约翰内斯堡大学孔子学院'
                        },
                        {
                            name: '西班牙莱昂大学孔子学院'
                        },
                        {
                            name: '泰国海上丝路孔子学院'
                        },
                        {
                            name: '英国兰卡斯特大学孔子学院'
                        },
                        {
                            name: '美国长老会学院孔子学院'
                        },
                        {
                            name: '美国新罕布什尔大学孔子学院'
                        },
                        {
                            name: '美国韦伯斯特大学孔子学院'
                        },
                        {
                            name: '美国纽约州立宾汉顿大学戏曲孔子学院'
                        },
                        {
                            name: '吉尔吉斯斯坦比什凯克市第69中学孔子课堂'
                        },
                        {
                            name: '尼泊尔LRI国际学校孔子课堂'
                        },
                        {
                            name: '英国威根雷学院孔子课堂'
                        }
                    ],
                    en: [
                        {
                            name: 'Confucius Institute at the University of Buenos Aires, Argentina'
                        },
                        {
                            name: 'Confucius Institute at the University of New South Wales Sydney, Australia'
                        },
                        {
                            name: 'Confucius Institute at the University of Western Australia, Australia'
                        },
                        {
                            name: 'Confucius Institute at University College West Flanders, Belgium'
                        },
                        {
                            name: 'Confucius Institute at Pará State University, Brazil'
                        },
                        {
                            name: 'Confucius Institute at Suez Canal University, Egypt'
                        },
                        {
                            name: 'Confucius Institute at University of Lorraine, France'
                        },
                        {
                            name: 'Confucius Institute at Frankfurt University, Germany'
                        },
                        {
                            name: 'Confucius Institute at University College Cork, Ireland'
                        },
                        {
                            name: 'Confucius Institute at Università Cattolica del Sacro Cuore, Italy'
                        },
                        {
                            name: 'Confucius Institute at Osaka Sangyo University, Japan'
                        },
                        {
                            name: 'Confucius Institute at National University of Laos, Laos'
                        },
                        {
                            name: 'Confucius Institute at University of Antananarivo, Madagascar'
                        },
                        {
                            name: 'Kong Zi Institute at the University of Malaya, Malaysia'
                        },
                        {
                            name: 'Confucius Institute at Victoria University of Wellington, New Zealand'
                        },
                        {
                            name: 'Confucius Institute at the University of Lagos, Nigeria'
                        },
                        {
                            name: 'Confucius Institute at the University of Panama, Panama'
                        },
                        {
                            name: 'Confucius Institute at Ural Federal University, Russia'
                        },
                        {
                            name: 'Confucius Institute at University of Novi Sad, Serbia'
                        },
                        {
                            name: 'Confucius Institute at University of Johannesburg, South Africa'
                        },
                        {
                            name: 'Confucius Institute at the University of Leon, Spain'
                        },
                        {
                            name: 'Maritime Silk Road Confucius Institute, Thailand'
                        },
                        {
                            name: 'Confucius Institute at Lancaster University, UK'
                        },
                        {
                            name: 'Confucius Institute at Presbyterian College, USA'
                        },
                        {
                            name: 'Confucius Institute at the University of New Hampshire, USA'
                        },
                        {
                            name: 'Confucius Institute at Webster University, USA'
                        },
                        {
                            name: 'Confucius Institute of Chinese Opera at Binghamton University, USA'
                        },
                        {
                            name: 'Confucius Classroom of Educational Teaching Complex No.69 by T.Satylganov in Bishkek, Kyrgyzstan'
                        },
                        {
                            name: 'Confucius Classroom at Learning Realm International (L.R.I.) College, Nepal'
                        },
                        {
                            name: 'Confucius Classroom at Wigan and Leigh College, UK'
                        }
                    ],
                },
                person: {
                    cn: [
                        {
                            name: '王国番',
                            profile: '阿富汗喀布尔大学孔子学院（中文系）汉语教师',
                            country: '阿富汗'
                        },
                        {
                            name: '凯利•史密斯',
                            profile: '澳大利亚乐卓博大学副校长兼乐卓博大学孔子学院院长',
                            country: '澳大利亚'
                        },
                        {
                            name: '赵坤',
                            profile: '玻利维亚圣西蒙大学孔子学院中方院长',
                            country: '玻利维亚'
                        },
                        {
                            name: '劳赛夫',
                            profile: '布隆迪大学孔子学院院长',
                            country: '布隆迪'
                        },
                        {
                            name: '肖旭',
                            profile: '柬埔寨大金欧兴中学校普通志愿者',
                            country: '柬埔寨'
                        },
                        {
                            name: '阿道夫·闵库阿·西',
                            profile: '喀麦隆雅温得第二大学校长，雅温得第二大学孔子学院理事长',
                            country: '喀麦隆'
                        },
                        {
                            name: '凯伦·查德',
                            profile: '加拿大萨斯喀彻温大学副校长，萨斯喀彻温大学孔子学院理事长',
                            country: '加拿大'
                        },
                        {
                            name: '王龙',
                            profile: '哥伦比亚安第斯大学孔子学院志愿者',
                            country: '哥伦比亚'
                        },
                        {
                            name: '李晓靖',
                            profile: '埃及开罗大学孔子学院汉语教师',
                            country: '埃及'
                        },
                        {
                            name: '何新香',
                            profile: '印度尼西亚玛琅国立大学孔子学院志愿者',
                            country: '印度尼西亚'
                        },
                        {
                            name: '张红',
                            profile: '意大利罗马大学孔子学院中方院长',
                            country: '意大利'
                        },
                        {
                            name: '川井伸一',
                            profile: '日本爱知大学校长，爱知大学孔子学院理事长',
                            country: '日本'
                        },
                        {
                            name: '马拉特',
                            profile: '吉尔吉斯斯坦奥什国立大学孔子学院“汉硕”本土教师',
                            country: '吉尔吉斯斯坦'
                        },
                        {
                            name: '李程',
                            profile: '墨西哥国立自治大学孔子学院中方院长',
                            country: '墨西哥'
                        },
                        {
                            name: '拉姆·施瑞斯塔',
                            profile: '尼泊尔加德满都大学校长，加德满都大学孔子学院理事长',
                            country: '尼泊尔'
                        },
                        {
                            name: '周兵',
                            profile: '新西兰奥克兰孔子学院中方院长',
                            country: '新西兰'
                        },
                        {
                            name: '邹维琴',
                            profile: '尼日利亚纳姆迪·阿齐克韦大学孔子学院志愿者',
                            country: '尼日利亚'
                        },
                        {
                            name: '鲁楠',
                            profile: '挪威卑尔根孔子学院院长',
                            country: '挪威'
                        },{
                            name: '崔锦路',
                            profile: '挪威卑尔根孔子学院志愿者',
                            country: '挪威'
                        },
                        {
                            name: '阿衣江·巴哈提汗',
                            profile: '巴基斯坦伊斯兰堡孔子学院汉语教师',
                            country: '巴基斯坦'
                        },
                        {
                            name: '沃伊切赫•诺瓦克',
                            profile: '波兰雅盖隆大学校长、克拉科夫孔子学院理事长',
                            country: '波兰'
                        },
                        {
                            name: '卡洛斯·莫伊拉斯',
                            profile: '葡萄牙阿威罗大学孔子学院院长',
                            country: '葡萄牙'
                        },{
                            name: '李昇勲',
                            profile: '韩国世翰大学校长，世翰大学孔子学院理事长',
                            country: '韩国'
                        },
                        {
                            name: '米尔恰·杜米特鲁',
                            profile: '罗马尼亚布加勒斯特大学校长，布加勒斯特大学孔子学院理事长',
                            country: '罗马尼亚'
                        },
                        {
                            name: '张蕈丽',
                            profile: '俄罗斯圣彼得堡私立补充教育“孔子”东方语言文化学院孔子课堂汉语教师',
                            country: '俄罗斯'
                        },
                        {
                            name: '苏珊娜',
                            profile: '俄罗斯莫斯科国立语言大学孔子学院“汉硕”本土教师',
                            country: '俄罗斯'
                        },{
                            name: '赫理普诺夫.I.G.',
                            profile: '俄罗斯新西伯利亚国立技术大学孔子学院院长',
                            country: '俄罗斯'
                        },
                        {
                            name: '曹亮',
                            profile: '俄罗斯乌拉尔联邦大学孔子学院海外志愿者',
                            country: '俄罗斯'
                        },{
                            name: '李乾超',
                            profile: '西班牙莱昂大学孔子学院志愿者',
                            country: '西班牙'
                        },
                        {
                            name: '艾努越',
                            profile: '西班牙巴塞罗那孔子学院“汉硕”本土教师',
                            country: '西班牙'
                        },{
                            name: '刘茜琳',
                            profile: '泰国南邦嘎拉娅尼学校孔子课堂志愿者',
                            country: '泰国'
                        },
                        {
                            name: '缪彧',
                            profile: '菲律宾红溪礼示大学孔子学院志愿者',
                            country: '菲律宾'
                        },{
                            name: '梁广寒',
                            profile: '菲律宾亚典耀大学孔子学院中方院长',
                            country: '菲律宾'
                        },
                        {
                            name: '刘艳晖',
                            profile: '阿联酋迪拜大学孔子学院中方院长',
                            country: '阿联酋'
                        },{
                            name: '于泓珊',
                            profile: '英国赫尔大学孔子学院汉语教师',
                            country: '英国'
                        },
                        {
                            name: '伊恩·蒙哥马利',
                            profile: '英国奥斯特大学副校长',
                            country: '英国'
                        },{
                            name: '祖迪',
                            profile: '美国阿拉巴马农工大学孔子学院志愿者',
                            country: '美国'
                        },
                        {
                            name: '李顺琴',
                            profile: '美国克利夫兰州立大学孔子学院汉语教师',
                            country: '美国'
                        },{
                            name: '修华静',
                            profile: '美国肯塔基大学孔子学院院长',
                            country: '美国'
                        },
                        {
                            name: 'Sang S. Kim',
                            profile: '美国密苏里大学孔子学院院长',
                            country: '美国'
                        },
                        {
                            name: '施健',
                            profile: '津巴布韦大学孔子学院汉语教师',
                            country: '津巴布韦'
                        }
                        
                    ],
                    en: [
                        {
                            name: 'Wang Guopan',
                            profile: 'Chinese Teacher of Confucius Institute (Chinese Department) at Kabul University, Afghanistan',
                            country: 'Afghanistan'
                        },
                        {
                            name: 'Kelly Smith',
                            profile: 'Pro Vice-Chancellor of La Trobe University (International), Director of Confucius Institute at La Trobe University, Australia',
                            country: 'Australia'
                        },
                        {
                            name: 'Zhao Kun',
                            profile: ' Chinese Director of Confucius Institute at the University Mayor of San Simón, Bolivia',
                            country: 'Bolivia'
                        },
                        {
                            name: 'Joseph Nzeyimana',
                            profile: 'Director of Confucius Institute at the University of Burundi',
                            country: 'Burundi'
                        },
                        {
                            name: 'Xiao Xu',
                            profile: 'Volunteer Chinese Teacher of Takmau Heng Tong Chinese School, Cambodia',
                            country: 'Cambodia'
                        },
                        {
                            name: 'Adolphe Minkoa She',
                            profile: 'President of University of Yaounde II, Chair of the Board of Confucius Institute at University of Yaounde II, Cameroon',
                            country: 'Cameroon'
                        },
                        {
                            name: 'Karen Chad',
                            profile: 'Vice-President of University of Saskatchewan, Chair of the Board of Confucius Institute at the University of Saskatchewan, Canada',
                            country: 'Canada'
                        },
                        {
                            name: 'Wang Long',
                            profile: 'Volunteer Chinese Teacher of Confucius Institute at University of the Andes, Colombia',
                            country: 'Colombia'
                        },
                        {
                            name: 'Li Xiaojing',
                            profile: 'Chinese Teacher of Confucius Institute at Cairo University, Egypt',
                            country: 'Egypt'
                        },
                        {
                            name: 'He Xinxiang',
                            profile: 'Volunteer Chinese Teacher of Confucius Institute at State University of Malang, Indonesia',
                            country: 'Indonesia'
                        },
                        {
                            name: 'Zhang Hong',
                            profile: 'Chinese Director of Confucius Institute at Sapienza University of Rome, Italy',
                            country: 'Italy'
                        },
                        {
                            name: 'Shinichi Kawai',
                            profile: 'President of Aichi University, Chair of the Board of Confucius Institute at Aichi University, Japan',
                            country: 'Japan'
                        },
                        {
                            name: 'Abdykulov Maratbek',
                            profile: 'Local MTCSOL Chinese Language Teacher of Confucius Institute at Osh State University, Kyrgyzstan',
                            country: 'Kyrgyzstan'
                        },
                        {
                            name: 'Li Cheng',
                            profile: 'Chinese Director of the Confucius Institute at the National Autonomous University of Mexico, Mexico',
                            country: 'Mexico'
                        },
                        {
                            name: 'Ram Kantha Makaju Shrestha',
                            profile: 'President of Kathmandu University, Chair of the Board of Confucius Institute at Kathmandu University, Nepal',
                            country: 'Nepal'
                        },
                        {
                            name: 'Zhou Bing',
                            profile: 'Deputy Director of Confucius Institute in Auckland, New Zealand',
                            country: 'New Zealand'
                        },
                        {
                            name: 'Zou Weiqin',
                            profile: 'Volunteer Chinese Teacher of Confucius Institute at Nanmdi Azikiwe University, Nigeria',
                            country: 'Nigeria'
                        },
                        {
                            name: 'Rune Ingebrigtsen',
                            profile: 'Director of Confucius Institute in Bergen, Norway',
                            country: 'Norway'
                        },{
                            name: 'Cui Jinlu',
                            profile: 'Volunteer Chinese Teacher of Confucius Institute in Bergen, Norway',
                            country: 'Norway'
                        },
                        {
                            name: 'Ayijiang Bahatihan',
                            profile: 'Chinese Teacher of Confucius Institute in Islamabad, Pakistan',
                            country: 'Pakistan'
                        },
                        {
                            name: 'Wojciech Nowak',
                            profile: 'Rector of Jagiellonian University, Chair of the Board of Confucius Institute at Jagiellonian University, Poland',
                            country: 'Poland'
                        },
                        {
                            name: 'Carlos Morais',
                            profile: 'Director of Confucius Institute at the University of Aveiro, Portugal',
                            country: 'Portugal'
                        },{
                            name: 'Yi Sunghoon',
                            profile: 'President of Sehan University, Chair of the Board of Confucius Institute at Sehan University, Republic of Korea',
                            country: 'Republic of Korea'
                        },
                        {
                            name: 'Mircea Dumitru',
                            profile: 'Rector of University of Bucharest, Chair of the Board of Confucius Institute at the University of Bucharest, Romania',
                            country: 'Romania'
                        },
                        {
                            name: 'Zhang Xunli',
                            profile: 'Chinese Teacher of Confucius Classroom at Private Institution Educational Organization of Supplementary Education (Confucius), Russia',
                            country: 'Russia'
                        },
                        {
                            name: 'Kara-Sal Siuzanna',
                            profile: 'Local MTCSOL Chinese Language Teacher of Confucius Institute at Moscow State Linguistic University, Russia',
                            country: 'Russia'
                        },{
                            name: 'Khripunov I.G.',
                            profile: 'Director of Confucius Institute at Novosibirsk State Technical University, Russia',
                            country: 'Russia'
                        },
                        {
                            name: 'Cao Liang',
                            profile: 'Overseas Volunteer Chinese Teacher of Confucius Institute at Ural Federal University, Russia',
                            country: 'Russia'
                        },{
                            name: 'Li Qianchao',
                            profile: 'Volunteer Chinese Teacher of Confucius Institute at University of Leon, Spain',
                            country: 'Spain'
                        },
                        {
                            name: 'Ainhoa Urmeneta Lafuente',
                            profile: 'Local MTCSOL Chinese Language Teacher of Confucius Institute in Barcelona, Spain',
                            country: 'Spain'
                        },{
                            name: 'Liu Xilin',
                            profile: 'Volunteer Chinese Teacher of Confucius Classroom at Lampang Kanlaynee School, Thailand',
                            country: 'Thailand'
                        },
                        {
                            name: 'Miao Yu',
                            profile: 'Volunteer Chinese Teacher of Confucius Institute at Angeles University Foundation, the Philippines',
                            country: 'the Philippines'
                        },{
                            name: 'Liang Guanghan',
                            profile: 'Chinese Director of Confucius Institute at Ateneo de Manila University, the Philippines',
                            country: 'the Philippines'
                        },
                        {
                            name: 'Liu Yanhui',
                            profile: 'Chinese Director of Confucius Institute at University of Dubai, UAE',
                            country: 'UAE'
                        },{
                            name: 'Yu Hongshan',
                            profile: 'Chinese Teacher of Confucius Institute at the University of Hull, UK',
                            country: 'UK'
                        },
                        {
                            name: 'Ian Montgomery',
                            profile: 'Pro-Vice-Chancellor of Ulster University, UK',
                            country: 'UK'
                        },{
                            name: 'Zu Di',
                            profile: 'Volunteer Chinese Teacher of Confucius Institute at Alabama A&M University, USA',
                            country: 'USA'
                        },
                        {
                            name: 'Li Shunqin',
                            profile: 'Chinese Teacher of Confucius Institute at Cleveland State University, USA',
                            country: 'USA'
                        },{
                            name: 'Huajing Maske',
                            profile: 'Director of Confucius Institute at the University of Kentucky, USA',
                            country: 'USA'
                        },
                        {
                            name: 'Sang S. Kim',
                            profile: 'Director of Confucius Institute at the University of Missouri, USA',
                            country: 'USA'
                        },
                        {
                            name: 'Shi Jian',
                            profile: 'Chinese Teacher of Confucius Institute at University of Zimbabwe, Zimbabwe',
                            country: 'Zimbabwe'
                        }
                        
                    ]
                },
                partner: {
                    cn: [
                        {
                            name: '北京外国语大学'
                        },
                        {
                            name: '北京语言大学'
                        },
                        {
                            name: '中国政法大学'
                        },{
                            name: '复旦大学'
                        },
                        {
                            name: '华东师范大学'
                        },{
                            name: '厦门大学'
                        },{
                            name: '天津外国语大学'
                        },{
                            name: '大连外国语大学'
                        },{
                            name: '浙江师范大学'
                        },{
                            name: '山东师范大学'
                        },{
                            name: '天津市教育委员会'
                        }
                    ],
                    en: [
                        {
                            name: 'Beijing Foreign Studies University'
                        },
                        {
                            name: 'Beijing Language and Culture University'
                        },
                        {
                            name: 'China University of Political Science and Law'
                        },{
                            name: 'Fudan University'
                        },
                        {
                            name: 'East China Normal University'
                        },{
                            name: 'Xiamen University'
                        },{
                            name: 'Tianjin Foreign Studies University'
                        },{
                            name: 'Dalian University of Foreign Languages'
                        },{
                            name: 'Zhejiang Normal University'
                        },{
                            name: 'Shandong Normal University'
                        },{
                            name: 'Tianjin Municipal Education Commission'
                        }
                    ]
                }
            }
      }
    },
    computed: {
        awardsSwiper() {
            return this.$refs.awardsSwiper.swiper
            
        },
    },
  methods: {
      close () {
          this.isShow = false
      },
      showModal (index) {
          this.current = index
          this.isShow = true
      }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
div::-webkit-scrollbar{
  width:5px;
  height:10px;
  /**/
}
div::-webkit-scrollbar-track{
  background: rgb(239, 239, 239);
  border-radius:4px;
}
div::-webkit-scrollbar-thumb{
  background: #f3bc65;
  border-radius:10px;
}
div::-webkit-scrollbar-thumb:hover{
  background: #333;
}
div::-webkit-scrollbar-corner{
  background: #179a16;
}
.newsPage {
    .top {
        margin-left: 55px;
        padding-top: 30px;
        .line {
            display: inline-block;
            width: 1px;
            height: 80px;
            background-color: rgba(255,255,255,0.5);
            margin: 0 45px;
            vertical-align: super;
        }
    }
    .main {
        max-width: 1400px;
        margin-left: 200px;
        .title {
            font-size: 60px;
            color: #f3bc65;
            font-weight: bold;
            margin: 28px 160px;
        }
        
        .firstWrapper {
            
            // width: 80%;
            height: 550px;
            margin-left: 66px;
        }
        .swiper-slide,.firstSwiper {
            text-align: center;
            /* Center slide text vertically */
            display: flex;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            -webkit-justify-content: center;
            justify-content: center;
            -webkit-box-align: center;
            -ms-flex-align: center;
            -webkit-align-items: center;
            align-items: center;
            transition: 300ms;
            transform: scale(0.8);
            cursor: pointer;
            img {
                width: 354px;
            }
        }
        .swiper-slide-active,.swiper-slide-duplicate-active{
            transform: translateY(10px) scale(1.2);
        }
    }
    // 模态框
    .modalCon {
        //display: none;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        
        z-index: 2000;
        
        .modalBg {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background-color: #000;
            opacity: 0.5;
            z-index: 2001;
        }
        .modal {
            position: absolute;
            z-index: 2002;
            margin: auto;
            left: 0;
            right: 0;
            width: 1084px;
            height: calc(100% - 40px);
            background-color: #fff;
            //background-image: url(../img/modal_top.svg);
            margin-top: 40px;
            .topBg {
                width: 1140px;
                height: calc(100% + 24px);
                transform: translateX(-2.9%) translateY(-24px);
                background-image: url('../img/modal_top.png');
                background-size: cover;
                background-repeat: no-repeat;
                
            }
            .modalContent {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-image: url(../img/Logo_CI.png);
                background-repeat: no-repeat;
                background-position: 50px 150px;
                .close {
                    position: absolute;
                    right: 4%;
                    top: 55px;
                    width: 29px;
                    height: 29px;
                    background-image: url(../img/close.png);
                    cursor: pointer;
                    z-index: 20;

                }
                .content {
                    width: 100%;
                    height: 100%;
                    .title {
                        text-align: center;
                        font-size: 60px;
                        color: #efae45;
                        font-weight: bold;
                        div:first-child {
                            margin: 81px auto 20px;
                        }
                        div:nth-child(2),div:nth-child(3) {
                            font-size: 30px;
                        }
                    }
                    .list {
                        width: calc(100% - 20px);
                        margin-right: 20px;
                        height: calc(100% - 280px);
                        overflow-y: auto;
                        word-break: break-all;
                        white-space: initial;
                        margin-top: 50px;
                        
                        .item {
                            width: 50%;
                            display: inline-block;
                            vertical-align: top;
                            text-align: left;
                            padding-left: 80px;
                            padding-right: 40px;
                            box-sizing: border-box;
                            margin-bottom: 30px;
                            line-height: 1.2;
                            word-break: initial;
                            .realName {
                                font-size: 22px;
                                color: #282828;
                                margin-right: 5px;
                            }
                            span {
                                color: #bd8a39;
                                font-size: 16px;
                            }
                            .profile {
                                font-size: 16px;
                                color: #666;
                                margin-top: 10px;
                                line-height: 1.4;
                                word-break: initial;
                            }
                            
                        }
                        .item:nth-child(odd) {
                            padding-left: 120px;
                            padding-right: 30px;
                        }
                        .item:nth-child(even) {
                            padding-left: 40px;
                            padding-right: 80px;
                        }
                        .partnerItem {
                            width: 100%;
                            padding-left: 0;
                            word-break: initial;
                            padding-right: 0;
                            font-size: 30px;
                            text-align: center;
                            .realName {
                                color: #282828;
                            }
                        }
                        .partnerItem_en {
                            font-size: 24px;
                        }
                        .partnerItem:nth-child(odd) {
                            padding-left: 0;
                            padding-right: 0;
                        }
                        .partnerItem:nth-child(even) {
                            padding-left: 0;
                            padding-right: 0;
                        }
                        .partnerItem_en:nth-child(odd) {
                            padding-left: 0;
                            padding-right: 0;
                        }
                        .partnerItem_en:nth-child(even) {
                            padding-left: 0;
                            padding-right: 0;
                        }
                        .classroomItem:nth-child(odd) {
                            padding-left: 160px;
                        }
                        .classroomItem_en:nth-child(odd) {
                            padding-left: 120px;
                        }
                    }
                    .classroomList {
                        .tip {
                            display: block;
                            color: #999;
                            padding-left: 160px;
                            margin-bottom: 20px;
                        }
                    }
                    .personList {
                        .tip {
                            display: block;
                            color: #999;
                            padding-left: 120px;
                            margin-bottom: 20px;
                        }
                    }
                    
                }
            }
        }
    }
    
}
@media screen and (min-width: 1240px) and (max-width: 1460px) {
.newsPage {
    .top {
        padding-top: 15px;
        margin-left: 30px;
        img:first-child {
            width: 127px;
        }
        .line {
            display: inline-block;
            width: 1px;
            height: 49px;
            background-color: rgba(255, 255, 255, 0.5);
            margin: 0 30px;
            vertical-align: super;
        }
        .imgRight {
            width: 294px;
        }
    }
    .main {
        margin-left: 28px;
        .title {
            font-size: 36px;
            margin: 28px 0;
        }
        .firstWrapper {
            width: 1065px;
            margin: 28px 0;
        }
    }
}

  
}
@media screen and (min-width: 1460px) and (max-width: 1680px) {
.newsPage {
    .main {
        margin-left: 0;
        float: left;
        .title {
            font-size: 36px;
            margin: 28px 60px;
        }
        .firstWrapper {
            width: 1100px;
            margin: 28px 60px;
        }
    }
}

  
}

</style>
